import React from "react";
import {
  TwoColumnSectionBase,
  CenteredGridWithHeading,
  IconTitleDescriptionActionCard,
} from "@reusejs/react";
import SectionHeading from "../SectionHeading";

const ImageSection = (props: any) => {
  return (
    <div className="mt-0 lg:mt-10  h-full w-full relative lg:mt-0 flex justify-center">
      {props.imgPattern && props.svgElement}
    </div>
  );
};

const DetailsSection = (props: any) => {
  let detailsSectionHeading = {
    title: props.sectionHeading,
    description: props.sectionDescription,
  };

  return (
    <CenteredGridWithHeading
      headingSection={
        <SectionHeading
          title={detailsSectionHeading.title}
          description={detailsSectionHeading.description}
          itemTitleDescriptionCardBaseClasses={{
            titleWrapper: "text-left",
            titleStyles:
              "text-xl lg:text-3xl font-semibold lg:font-extrabold sm:text-4xl",
            descriptionWrapper: "text-left",
            descriptionStyles:
              "mt-3 text-base lg:text-lg sm:mt-4 text-gray-500",
          }}
        />
      }
      footerSection={props.footerActions}
      sectionContentData={props.sectionItems}
      itemsRenderer={ItemRendererComponent}
      centeredGridBaseClasses={{
        gridClasses: "sm:space-y-0 grid grid-cols-1 py-2",
        gridWrapper: "mt-4 border-t-2",
        verticalWrapperPadding: "py-0",
        horizontalPadding: "px-0 md:px-4",
      }}
    />
  );
};

const ItemRendererComponent = (props?: any) => {
  return (
    <>
      {props.items.map((item?: any, index?: number) => {
        return (
          <IconTitleDescriptionActionCard
            key={index}
            title={item.title}
            icon={item.icon}
            iconPosition="left"
            itemTitleDescriptionCardBaseClasses={{
              wrapper: "relative py-0 pt-2 lg:pt-2 lg:py-2 bg-white",
              titleWrapper: "ml-7",
              titleStyles: "text-base leading-6 font-regular",
              descriptionWrapper: "mt-2",
              descriptionStyles: "text-base text-gray-500 font-medium",
              actionWrapper: "mt-2",
              iconWrapper:
                "flex items-center justify-center bg-green-100 rounded-full",
            }}
          />
        );
      })}
    </>
  );
};

export default function ServiceDetailSection(props: any) {
  return (
    <>
      <TwoColumnSectionBase
        firstColumnEl={
          <>
            {/* web */}
            <div className="hidden lg:flex">
              <DetailsSection
                sectionHeading={props.sectionHeading}
                sectionDescription={props.sectionDescription}
                sectionItems={props.sectionItems}
                footerActions={props.footerActions}
              />
            </div>
            {/* mobile */}
            <div className="flex lg:hidden">
              <ImageSection
                imgPattern={props.imgPattern}
                imgUrl={props.imgUrl}
                svgElement={props.svgElement}
              />
            </div>
          </>
        }
        secondColumnEl={
          <>
            {/* web */}
            <div className="hidden lg:flex">
              <ImageSection
                imgPattern={props.imgPattern}
                imgUrl={props.imgUrl}
                svgElement={props.svgElement}
              />
            </div>
            {/* mobile */}
            <div className="flex lg:hidden">
              <DetailsSection
                sectionHeading={props.sectionHeading}
                sectionDescription={props.sectionDescription}
                sectionItems={props.sectionItems}
                footerActions={props.footerActions}
              />
            </div>
          </>
        }
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full md:w-1/2",
          secondElWrapperStyles: "w-full md:w-1/2 self-stretch",
          columnsFlexWrapperStyles: `flex items-start justify-between ${
            props.reverseFlexDirection
              ? "flex-col md:flex-row-reverse"
              : "flex-col md:flex-row"
          }`,
        }}
      />
    </>
  );
}
